import { Injectable } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import {
  LoginGenerateShiprocketResponse,
  LoginVerifyResponse,
  ShiprocketVerifyRequestLoginMethodEnum,
} from '@cureskin/api-client/src/server-api/api';

/** Minimal shape of the error surfaced by serverApi (axios) / legacy HttpClient calls. */
interface ApiErrorLike {
  response?: { data?: { message?: string } };
  error?: { message?: string };
}

export interface ShiprocketGenerateParams {
  countryCode: string;
  mobileNumber: string;
  source: string;
  deviceId: string;
}

export interface ShiprocketVerifyParams {
  mobileNumber: string;
  token: string;
  OTP: string;
  installationId: string;
  source?: string;
  deviceId?: string;
  aaid?: string;
  userAddressConsent?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ShiprocketLoginService {
  token: string | null = null;

  userAddressConsent: boolean = true;

  constructor(private readonly conn: ConnectionService) {}

  async generate(params: ShiprocketGenerateParams): Promise<LoginGenerateShiprocketResponse> {
    try {
      return await this.conn.loginGenerateShiprocket(params);
    } catch (error) {
      throw new Error(ShiprocketLoginService.extractMessage(error));
    }
  }

  async verify(params: ShiprocketVerifyParams): Promise<LoginVerifyResponse> {
    try {
      return await this.conn.loginVerifyShiprocket({
        loginMethod: ShiprocketVerifyRequestLoginMethodEnum.shiprocket,
        userAddressConsent: true,
        ...params,
      });
    } catch (error) {
      throw new Error(ShiprocketLoginService.extractMessage(error));
    }
  }

  private static extractMessage(error: unknown): string {
    const err = error as ApiErrorLike;
    return err?.response?.data?.message || err?.error?.message || $localize`:@@somethingWentWrongTryAgain:Something went wrong. Please try again.`;
  }
}
